import type { FormSection } from '../types'

type Props = {
  sections: FormSection[]
  selected: string[]
  onChange: (codes: string[]) => void
  disabled?: boolean
}

/**
 * Lista checkboxów do wyboru wielu sekcji jednocześnie.
 * Używana w FieldFormSheet (pole przypisane do N sekcji - sectionCodes).
 */
export function SectionCheckboxList({ sections, selected, onChange, disabled }: Props) {
  const toggle = (code: string) => {
    if (selected.includes(code)) {
      onChange(selected.filter(c => c !== code))
    } else {
      onChange([...selected, code])
    }
  }

  if (sections.length === 0) {
    return (
      <p className="text-xs text-slate-400 italic">
        Brak sekcji - dodaj sekcję przed dodaniem pola.
      </p>
    )
  }

  return (
    <div className="flex flex-col gap-1">
      {sections.map(s => (
        <label
          key={s.code}
          className="flex items-center gap-2 rounded border border-slate-200 bg-white px-2.5 py-1.5 text-sm cursor-pointer hover:bg-slate-50 has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-60"
        >
          <input
            type="checkbox"
            checked={selected.includes(s.code)}
            onChange={() => toggle(s.code)}
            disabled={disabled}
            className="size-4 accent-sky-600 shrink-0"
          />
          <span className="flex-1 truncate text-slate-900">{s.labelPl}</span>
          <span className="font-mono text-[10px] text-slate-400 shrink-0">{s.code}</span>
          {s.renderTarget === 'SIDEBAR' && (
            <span className="rounded bg-indigo-100 text-indigo-700 px-1 py-0.5 text-[10px] font-medium shrink-0">
              Sidebar
            </span>
          )}
        </label>
      ))}
    </div>
  )
}
